import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/app/Sidebar";
import TopBar from "@/components/app/TopBar";
import { useState } from "react";
import ReminderDialog from "@/components/app/ReminderDialog";
import ClientDialog from "@/components/app/ClientDialog";

export default function AppLayout() {
  const [reminderOpen, setReminderOpen] = useState(false);
  const [clientOpen, setClientOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-hidden bg-stone-50">
      <Sidebar currentPath={location.pathname} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar
          onNewReminder={() => setReminderOpen(true)}
          onNewClient={() => setClientOpen(true)}
        />
        <main className="flex-1 overflow-y-auto">
          <Outlet context={{
            openReminder: () => setReminderOpen(true),
            openClient: () => setClientOpen(true),
          }} />
        </main>
      </div>

      <ReminderDialog
        open={reminderOpen}
        onOpenChange={setReminderOpen}
        onSaved={() => window.dispatchEvent(new Event("crm:data-changed"))}
      />
      <ClientDialog
        open={clientOpen}
        onOpenChange={setClientOpen}
        onSaved={() => window.dispatchEvent(new Event("crm:data-changed"))}
      />
    </div>
  );
}
